module.exports = __webpack_public_path__ + "static/media/dumpster-inactive.204c0e12.svg";